import { Weapon } from '../../Weapon.js';
import { FUSED_WEAPONS } from '../../../../../config/constants.js';

/**
 * Static Bloom (Harmonics fusion: Nova Pulse + Arc Needle) — the periodic
 * self-centered pulse, but every bloom also launches homing needles from
 * its rim at the current target. At max fusion level the needles carry the
 * stacking DoT (CombatSystem._applyDotStack — Orbit Ward's field, reused).
 */
export class StaticBloom extends Weapon {
  constructor() {
    super(FUSED_WEAPONS.staticBloom);
  }

  fire(origin, target, pool) {
    const radius = this.config.radius + this.level * 2;
    pool.fire({
      x: origin.x,
      y: origin.y,
      radius,
      damage: this.config.pulseDamage + this.level * this.config.pulseDamagePerLevel,
      hits: 1,
      lifetime: 0.15,
      color: this.config.color,
      style: 'ring',
    });

    if (!target) return;
    // Rounded halves, not +1 per level: the needles are a real share of the
    // weapon's output, so doubling their count across the ladder would spend
    // the entire L1->max damage budget on count alone (see FUSED_WEAPONS).
    const needleCount = 3 + Math.round(this.level / 2);
    const toTarget = Math.atan2(target.y - origin.y, target.x - origin.x);
    for (let i = 0; i < needleCount; i++) {
      // Rim points on the target-facing half of the pulse, fanned evenly.
      const rimAngle = toTarget + ((i / Math.max(1, needleCount - 1)) * 2 - 1) * (Math.PI / 3);
      pool.fire({
        x: origin.x + Math.cos(rimAngle) * radius * 0.5,
        y: origin.y + Math.sin(rimAngle) * radius * 0.5,
        vx: Math.cos(rimAngle) * this.config.needleSpeed,
        vy: Math.sin(rimAngle) * this.config.needleSpeed,
        radius: 1.5,
        damage: this.config.needleDamage + this.level * this.config.needleDamagePerLevel,
        hits: 1,
        lifetime: this.config.needleLifetime,
        color: '#8ad1ff',
        homing: true,
        turnRate: this.config.needleTurnRate,
        target,
        appliesDot: this.level >= this.config.maxLevel,
        dotDamagePerTick: 3,
      });
    }
  }
}
